
export function showElements(classes) {
  for (let className in classes) {
    const elements = document.getElementsByClassName(className);
    for (let i = 0; i < elements.length; i++) {
      elements[i].hidden = !classes[className]
    }
  }
}
